import http from '~/common/http'
import Function from '~/common/functions'

//规则列表
function index(params){
    // console.log(params);
    return http.get('/api/login-rules/rule-index',{params:params})
}

//规则编辑展示
function view(id){
    return http.get('/api/login-rules/rule-view?id='+id)
}
//禁止规则编辑
function disable_rule_update(params){;
    return http.post('/api/login-rules/rule-disable-operate',params)
}
//规则编辑操作
function update(params) {
    return http.post('/api/login-rules/rule-update',params)
}
//查看日志
function lookLog(params) {
    return http.get('/api/login-rules/rule-look-logs',{params:params})
}
//删除禁用规则
function deleteRule(id) {
    return http.get('/api/login-rules/delete-disable-rule?id='+id)
}



export default {
    index,
    view,
    disable_rule_update,
    update,
    lookLog,
    deleteRule
}


// WEBPACK FOOTER //
// ./src/services/Rule.js